import React from 'react';

const ScheduleList = (props) => (
  <dl className="schedule-list__list">
    {props.List &&
      props.List?.map((item, index) => (
        <div key={index} className="schedule-list__list__row">
          {item.Day && (
            <dt className="schedule-list__list__item schedule-list__list__title">
              {item.Day}
            </dt>
          )}
          {item.Spans &&
            item.Spans?.map((span, index) => (
              <React.Fragment key={index}>
                {span.Period && (
                  <dd className="schedule-list__list__item schedule-list__list__item__period">
                    {span.Period}
                  </dd>
                )}
                {span.Comment && (
                  <dd className="schedule-list__list__item schedule-list__list__item__comment">
                    {span.Comment}
                  </dd>
                )}
              </React.Fragment>
            ))}
        </div>
      ))}
  </dl>
);

export default ScheduleList;
